module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0117.png.b2dd6336.jpg";